(function ($) {
    "use strict";

    // Spinner
    var spinner = function () {
        setTimeout(function () {
            if ($('#spinner').length > 0) {
                $('#spinner').removeClass('show');
            }
        }, 1);
    };
    spinner();
    
    
    // Initiate the wowjs - COMMENTED OUT TO FIX UNCAUGHT REFERENCE ERROR
    // new WOW().init();


    // Sticky Navbar
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.sticky-top').css('top', '0px');
        } else {
            $('.sticky-top').css('top', '-100px');
        }
    });
    
    
    // Dropdown on mouse hover
    const $dropdown = $(".dropdown");
    const $dropdownToggle = $(".dropdown-toggle");
    const $dropdownMenu = $(".dropdown-menu");
    const showClass = "show";
    
    $(window).on("load resize", function() {
        if (this.matchMedia("(min-width: 992px)").matches) {
            $dropdown.hover(
            function() {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function() {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
            );
        } else {
            $dropdown.off("mouseenter mouseleave");
        }
    });
    
    
    // Back to top button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.back-to-top').fadeIn('slow');
        } else {
            $('.back-to-top').fadeOut('slow');
        }
    });
    $('.back-to-top').click(function () {
        $('html, body').animate({scrollTop: 0}, 1500, 'easeInOutExpo');
        return false;
    });
    









    $(document).ready(function() {
  
  // Wrap the counter logic in a reusable function
  function startCounting() {
    $('.counter').each(function() {
      var $this = $(this);
      var countTo = $this.attr('data-target');

      $({ countNum: $this.text() }).animate({
        countNum: countTo
      }, {
        duration: 2000, // Speed of the animation in ms
        easing: 'swing',
        step: function() {
          // Update the text as it counts
          // Use Math.floor to keep it to whole numbers
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          // Final value check to ensure it hits the exact target
          $this.text(this.countNum >= 1000 ? (this.countNum / 1000).toFixed(0) + 'k' : this.countNum);
        }
      });
    });
  }

  // Run the function
  startCounting();
  
});



$(document).ready(function() {
    $('.read-more-btn, .read-less-btn').on('click', function(e) {
        e.preventDefault();

        var $clickedBox = $(this).closest('.service-box');
        var isOpening = !$clickedBox.hasClass('active');

        // Collapse all sections
        $('.service-box').removeClass('active');

        if (isOpening) {
            $clickedBox.addClass('active');
            
            // Wait a moment for the animation to start, then scroll
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $clickedBox.offset().top
                }, 600);
            }, 100);
        }
    });
});


    // ----- Mega Menu (vanilla JS, inside jQuery ready) -----
    $(document).ready(function() {
        console.log('Initializing mega menus…'); // Check console to confirm this runs

        const megaMenus = document.querySelectorAll(".has-mega");

        if (megaMenus.length === 0) {
            console.warn('No .has-mega elements found.');
        }

        megaMenus.forEach(menu => {
            let closeTimer;

            const openMenu = () => {
                clearTimeout(closeTimer);
                menu.classList.add("active");
            };

            const closeMenu = () => {
                closeTimer = setTimeout(() => {
                    menu.classList.remove("active");
                }, 100); // Small delay so you can move into the menu
            };

            menu.addEventListener("mouseenter", openMenu);
            menu.addEventListener("mouseleave", closeMenu);

            const mega = menu.querySelector(".mega-menu");
            if (mega) {
                mega.addEventListener("mouseenter", openMenu);
                mega.addEventListener("mouseleave", closeMenu);
            }
        });
    });

})(jQuery);